/* MediVerified: two-step reward progress (free delivery, then the free gift), free-gift auto add,
   and the 2pm dispatch countdown. */
(function () {
  var CFG = window.MV_CONFIG || {};
  var threshold = Number(CFG.thresholdPence || 10000); /* free gift */
  var delivery = Number(CFG.deliveryPence || 5000); /* free Standard delivery */
  if (delivery > threshold) delivery = threshold;
  var giftVariant = Number(CFG.giftVariantId || 0);
  var giftProduct = Number(CFG.giftProductId || 0);
  var giftEnabled = !!CFG.giftAutoAdd && giftVariant > 0;
  var giftName = CFG.giftName || 'free 9-slot vial case';
  var giftWorth = CFG.giftWorth || '£14.99';
  var cutoffHour = Number(CFG.cutoffHour || 14);
  var busy = false;

  function money(pence) {
    var n = Math.round(pence) / 100;
    var s = n.toFixed(2);
    if (s.slice(-3) === '.00') s = s.slice(0, -3);
    return '£' + s;
  }

  function qualifying(cart) {
    var q = cart.items_subtotal_price || 0;
    (cart.items || []).forEach(function (it) {
      if (it.sku === 'DELIVERYPLUS' || (it.properties && it.properties._mv_gift)) q -= it.final_line_price || 0;
    });
    return Math.max(0, q);
  }

  function message(cart, q) {
    if (!cart.item_count) {
      if (delivery < threshold) return 'Spend ' + money(delivery) + ' for free delivery, or ' + money(threshold) + ' for free delivery and a ' + giftName + ' (worth ' + giftWorth + ').';
      return 'Spend ' + money(threshold) + ' for free delivery and a ' + giftName + ' (worth ' + giftWorth + ').';
    }
    if (q >= threshold) return 'Unlocked: free delivery and your ' + giftName + '.';
    if (q >= delivery) return 'Free delivery unlocked. Add ' + money(threshold - q) + ' more for a ' + giftName + ' (worth ' + giftWorth + ').';
    if (delivery < threshold) return 'Add ' + money(delivery - q) + ' more for free delivery, ' + money(threshold - q) + ' for a ' + giftName + ' too.';
    return 'Add ' + money(threshold - q) + ' more for free delivery and a ' + giftName + ' (worth ' + giftWorth + ').';
  }

  function paint(cart) {
    var q = qualifying(cart);
    var hit = q >= threshold;
    var deliveryHit = q >= delivery;
    var pct = Math.min(100, Math.round((q / threshold) * 100));
    document.querySelectorAll('[data-mv-reward]').forEach(function (el) {
      el.classList.toggle('mv-reward--hit', hit);
      el.classList.toggle('mv-reward--delivery', deliveryHit && !hit);
      var fill = el.querySelector('[data-mv-reward-fill]');
      if (fill) fill.style.width = pct + '%';
      var track = el.querySelector('[role="progressbar"]');
      if (track) track.setAttribute('aria-valuenow', pct);
      var text = el.querySelector('[data-mv-reward-text]');
      if (text) text.textContent = message(cart, q);
      var ds = el.querySelector('[data-mv-reward-delivery-status]');
      if (ds) ds.textContent = deliveryHit ? 'Unlocked' : money(delivery - q) + ' to go';
      var status = el.querySelector('[data-mv-reward-status]');
      if (status) status.textContent = hit ? 'Unlocked' : money(threshold - q) + ' to go';
    });
    document.querySelectorAll('[data-mv-reward-gap]').forEach(function (el) { el.textContent = hit ? '' : money(threshold - q); });
    return { q: q, hit: hit };
  }

  function rerenderCart() {
    var items = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
    if (items && typeof items.onCartUpdate === 'function') { try { items.onCartUpdate(); } catch (e) {} }
    try {
      fetch(window.location.pathname + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections['cart-icon-bubble'];
          var bubble = document.getElementById('cart-icon-bubble');
          if (html && bubble) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('.shopify-section');
            bubble.innerHTML = fresh ? fresh.innerHTML : html;
          }
        }).catch(function () {});
    } catch (e) {}
  }

  /* Safety net: if the automatic Buy-X-get-Y discount is missing, the gift would be charged at full price.
     After adding, we re-read the cart; if the gift line is not free we remove it and stop trying this session. */
  function disabledBySafety() { try { return sessionStorage.getItem('mv_gift_off_v2') === '1'; } catch (e) { return false; } }
  function disableGift() { giftEnabled = false; try { sessionStorage.setItem('mv_gift_off_v2', '1'); } catch (e) {} }

  function manageGift(cart) {
    if (!giftEnabled || busy || disabledBySafety()) return;
    var state = paint(cart);
    var giftLine = (cart.items || []).filter(function (it) { return it.product_id === giftProduct && it.properties && it.properties._mv_gift; })[0];
    var r = window.routes || {};
    if (state.hit && giftLine && giftLine.properties && giftLine.properties._mv_gift && giftLine.final_line_price > 0 && cart.item_count > 1) {
      /* The gift we added is being charged: the discount is not set up. Remove it and stop. */
      busy = true;
      fetch((r.cart_change_url || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 0 })
      }).then(function () { busy = false; disableGift(); rerenderCart(); refresh(); }).catch(function () { busy = false; disableGift(); });
      return;
    }
    if (state.hit && !giftLine) {
      busy = true;
      fetch((r.cart_add_url || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: giftVariant, quantity: 1, properties: { _mv_gift: 'yes' } }] })
      }).then(function () { busy = false; rerenderCart(); refresh(); }).catch(function () { busy = false; });
    } else if (!state.hit && giftLine && giftLine.properties && giftLine.properties._mv_gift) {
      busy = true;
      fetch((r.cart_change_url || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 0 })
      }).then(function () { busy = false; rerenderCart(); refresh(); }).catch(function () { busy = false; });
    }
  }

  function refresh() {
    var r = window.routes || {};
    fetch((r.cart_url || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { paint(cart); manageGift(cart); })
      .catch(function () {});
  }

  /* ---- 2pm UK dispatch countdown ---- */
  function ukParts() {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).formatToParts(new Date());
    var g = function (t) { var f = parts.filter(function (p) { return p.type === t; })[0]; return f ? f.value : ''; };
    return { wd: g('weekday'), h: +g('hour') % 24, m: +g('minute'), s: +g('second') };
  }
  function cutoffText() {
    try {
      var u = ukParts();
      var secs = u.h * 3600 + u.m * 60 + u.s, cut = cutoffHour * 3600;
      var weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(u.wd) >= 0;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      if (weekday && secs < cut) {
        var left = cut - secs;
        return { live: true, text: 'Order within ' + pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60) + ' for same-day dispatch' };
      }
      var monday = u.wd === 'Sat' || u.wd === 'Sun' || (u.wd === 'Fri' && secs >= cut);
      return { live: false, text: 'Order now and it leaves ' + (CFG.dispatchFrom || 'Belfast') + ' ' + (monday ? 'on Monday' : 'tomorrow') };
    } catch (e) { return { live: false, text: 'Dispatched the next working day from ' + (CFG.dispatchFrom || 'Belfast') }; }
  }
  function tick() {
    var els = document.querySelectorAll('[data-mv-cutoff]');
    if (!els.length) return;
    var c = cutoffText();
    els.forEach(function (el) { el.textContent = c.text; el.classList.toggle('mv-cutoff--live', c.live); });
  }

  function init() {
    tick(); setInterval(tick, 1000);
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 150); });
    }
    document.addEventListener('mv:cart-changed', function () { setTimeout(refresh, 150); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.MV = { refresh: refresh, money: money, cutoffText: cutoffText };
})();
